import React, {Component} from 'react';
import {FormattedHTMLMessage, FormattedMessage, injectIntl} from 'react-intl';
import './OfferTile.less';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash';

export class OfferTile extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        paymentRate: PropTypes.string,
        paymentDuration: PropTypes.number,
        apr: PropTypes.string,
        totalInterestAmount: PropTypes.string,
        totalCostAmount: PropTypes.string,
        financingCode: PropTypes.string.isRequired,
        isInstallment: PropTypes.bool,
        className: PropTypes.string,
        isSelectable: PropTypes.bool.isRequired,
        dueToday: PropTypes.string,
        onClick: PropTypes.func,
        isEzpCycoPageBrandingTreatment: PropTypes.bool,

        // Provided by Field HOC
        input: PropTypes.object.isRequired,
        meta: PropTypes.object.isRequired,
        localePrefix: PropTypes.string.isRequired
    };

    static defaultProps = {
        isSelectable: true,
        className: ''
    };

    render() {
        const {
            apr,
            id,
            input,
            meta: { touched, active, error },
            className,
            dueToday,
            financingCode,
            isInstallment,
            isSelectable,
            paymentRate,
            paymentDuration,
            totalCostAmount,
            totalInterestAmount,
            onClick,
            localePrefix,
            isEzpCycoPageBrandingTreatment,
        } = this.props;

        const tileProps = {};
        if (isSelectable) {
            tileProps.onClick = onClick;
        }

        const inputName = input.name || id;
        const hasError = !!error && !!touched;

        return (
            <React.Fragment>
                <input
                    {...input}
                    className="offerTileRadio"
                    type="radio"
                    id={id}
                    name={inputName}
                    value={financingCode}
                    checked={input.value === financingCode}
                    disabled={!isSelectable}
                />
                <label className={`offerTile ${className} ${hasError ? 'hasError' : ''}`} htmlFor={`control_${financingCode}`} {...tileProps}>
                    <div className="offerTileLine1">
                        {isInstallment ?
                            <FormattedHTMLMessage
                                id={isEzpCycoPageBrandingTreatment ? `${localePrefix}.ezp-offer-tile-inst-title` : `${localePrefix}.offer-tile-inst-title`}
                                values={{ payment_rate: paymentRate, payment_duration: paymentDuration}}
                            /> : // TODO: dynamic interval messaging in the future
                            <FormattedMessage id={`${localePrefix}.offer-tile-ni-title`} />
                        }
                    </div>
                    <div className="offerTileLine2">
                        {isInstallment ?
                            <React.Fragment>
                                {`${apr} `}
                                <FormattedMessage id={`${localePrefix}.offer-tile-inst-apr-label`} />
                            </React.Fragment> :
                            <FormattedMessage id={`${localePrefix}.offer-tile-ni-desc`} />
                        }
                    </div>
                    {isInstallment && (
                        <div className="offerTileLine3">
                            <table className="offerTileDetail">
                                <tbody>
                                    <tr>
                                        <td className="rowDescription">
                                            <FormattedMessage id={isEzpCycoPageBrandingTreatment ? `${localePrefix}.ezp-offer-tile-inst-interest-label` : `${localePrefix}.offer-tile-inst-interest-label`} />
                                        </td>
                                        <td className="rowAmount">{totalInterestAmount}</td>
                                    </tr>
                                    {dueToday && (
                                        <tr>
                                            <td className="rowDescription">
                                                <FormattedMessage id={`${localePrefix}.offer-tile-inst-due-today-label`} />
                                            </td>
                                            <td className="rowAmount">{dueToday}</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td className="rowDescription">
                                            <FormattedMessage id={isEzpCycoPageBrandingTreatment ? `${localePrefix}.ezp-offer-tile-inst-payment-label` : `${localePrefix}.offer-tile-inst-payment-label`} /> 
                                        </td>
                                        <td className="rowAmount">{totalCostAmount}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </label>
            </React.Fragment>
        );
    }
}

export const mapStateToProps = state => ({
    isEzpCycoPageBrandingTreatment: _.get(state, 'serverData.elmo.EzpCycoPageBranding') === 'treatment_1'
});

export default connect(mapStateToProps)(injectIntl(OfferTile));
